export default __webpack_public_path__ + "static/media/falcon-ceb.b109b7ed.svg";